import React, { useMemo } from 'react';

import { statusItems } from '../../../providers/statusItems';
import { useTrackingRefuel } from '../../../hooks/useTrackingRefuel';

import { Container, TabItem, TabText } from './styles';

type TabsMobileProps = {
  activeTab: number;
  handleActiveTab: (tab: number) => void;
};

const TabsMobile: React.FC<TabsMobileProps> = ({
  activeTab,
  handleActiveTab,
}) => {
  const { counterData } = useTrackingRefuel();

  const isEmpty = Object.keys(counterData).length === 0;

  const dataItems = useMemo(() => {
    const data = statusItems.map((item) => {
      if (isEmpty) {
        return {
          ...item,
          count: 0,
        };
      }

      const counts = counterData?.statusOrderCount?.filter((counter) => {
        if (Array.isArray(item?.statusId)) {
          return item.statusId.includes(counter.status);
        }
        return counter.status === item.statusId;
      });

      const totalOccurrences = counts.reduce(
        (acc, curr) => acc + (curr.occurence || 0),
        0
      );

      return {
        ...item,
        count: totalOccurrences,
      };
    });

    return data;
  }, [counterData, isEmpty]);

  return (
    <Container>
      <TabItem
        active={activeTab === 0}
        onClick={() => {
          handleActiveTab(0);
        }}
      >
        <TabText active={activeTab === 0}>Todos</TabText>
      </TabItem>
      {dataItems.map((item) => (
        <TabItem
          key={item.id}
          active={activeTab === item.id}
          onClick={() => {
            handleActiveTab(item.id);
          }}
        >
          <TabText active={activeTab === item.id}>{item.name}</TabText>
        </TabItem>
      ))}
    </Container>
  );
};

export default TabsMobile;
